function normalizeComponentNodeForSave (node) {
  if (!node || node.type !== 'Image' || !node.style) return node

  const style = node.style
  const scaleX = style.scaleX === undefined ? 1 : style.scaleX
  const scaleY = style.scaleY === undefined ? 1 : style.scaleY

  return {
    ...node,
    style: {
      ...style,
      width: Math.round(style.width * scaleX),
      height: Math.round(style.height * scaleY),
      scaleX: 1,
      scaleY: 1
    }
  }
}

function replaceEditorNodeById (list, node) {
  return list.map(item => item.id === node.id ? node : item)
}

module.exports = {
  normalizeComponentNodeForSave,
  replaceEditorNodeById
}
